import { render, staticRenderFns } from "./BodyGraphComposite.vue?vue&type=template&id=4a3e5d0a&scoped=true&"
import script from "./BodyGraphComposite.vue?vue&type=script&lang=js&"
export * from "./BodyGraphComposite.vue?vue&type=script&lang=js&"
import style0 from "./BodyGraphComposite.vue?vue&type=style&index=0&id=4a3e5d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3e5d0a",
  null
  
)

export default component.exports